/* eslint-disable react/require-default-props */
import React from 'react';
import Select from '../Select';
import { useInspectionStatuses } from './useInspectionStatuses';
import Loader, { LoaderSizes } from '../Loader';
export default function InspectionStatusSelector({ id, className, value, onChange, placeholderText = 'Select a status...', errorText = 'Error loading statuses', allowClear = true, showSearch = false, searchPlaceholder = 'Search statuses...', maxHeight, blackListStatus = [] }) {
    const { data: statuses = [], isLoading, error } = useInspectionStatuses();
    // Filter out blacklisted statuses and transform into Select options with icon and color
    const filteredStatuses = statuses.filter((status) => !blackListStatus.includes(status.value));
    const options = filteredStatuses.map((status) => ({
        value: status.value,
        label: (React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement("i", { className: status.icon, style: { color: status.color, marginRight: '8px', fontSize: '14px' } }),
            React.createElement("span", null, status.name))),
        icon: status.icon,
        color: status.color
    }));
    // Conditionally add empty option for clearing selection based on allowClear prop
    const allOptions = allowClear || !value
        ? [
            {
                value: '',
                label: React.createElement("span", null, placeholderText)
            },
            ...options
        ]
        : options;
    const handleChange = (selectedValue) => {
        if (!selectedValue) {
            onChange(null);
            return;
        }
        const selectedStatus = filteredStatuses.find((status) => status.value === selectedValue);
        onChange(selectedStatus || null);
    };
    if (isLoading) {
        return React.createElement(Loader, { size: LoaderSizes.small });
    }
    if (error) {
        return React.createElement("div", { className: "text-danger" }, errorText);
    }
    return (React.createElement(Select, { id: id, className: className, value: value || '', onChange: handleChange, options: allOptions, showSearch: showSearch, searchPlaceholder: searchPlaceholder, maxHeight: maxHeight }));
}
